export default "__VITE_ASSET__Qvn9WQ6X__"